import gql from 'graphql-tag';

import { MockExamStudentProfileFragment } from './fragments/MyProfileFragment';

export const mockExamStudentProfile = gql`
  query mockExamStudentProfile($roundCode: ID!) {
    mockExamStudentProfile(mockExamRoundCode: $roundCode) {
      ...MockExamStudentProfileFragment
    }
  }
  ${MockExamStudentProfileFragment}
`;

export const studentProfileWithExamRound = gql`
  query studentProfileWithExamRound($roundCode: ID!) {
    mockExamStudentProfile(mockExamRoundCode: $roundCode) {
      ...MockExamStudentProfileFragment
    }
    mockExamSchoolRound(mockExamRoundCode: $roundCode) {
      roundId
      roundCode
      title
    }
  }
  ${MockExamStudentProfileFragment}
`;
